<c-row class="mb-3">
  <c-col xs>
    <div class="d-flex align-items-center gap-2">
      <label class="form-label mb-0 me-2">Date:</label>
      <input type="date" class="form-control form-control-sm w-auto" [value]="currentTime" (change)="onDateChange($event)" [max]="getCurrentDateInTimeZone(timeZone)" />
      <button type="button" class="btn btn-primary btn-sm mx-2" [disabled]="loading" (click)="getDtrToday(currentTime)">
        Refresh
        <c-spinner class="text-white" variant="border" label="Loading..." size="sm" *ngIf="loading"></c-spinner>
      </button>
    </div>
  </c-col>
</c-row>
<c-row>
  <c-col xs>
    <c-card class="mb-4">
      <c-card-body>
        <!-- Tabs for Clocked In and Absent -->
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'clockedIn'" (click)="onTabChange('clockedIn')" href="javascript:void(0)">Clocked In</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'absent'" (click)="onTabChange('absent')" href="javascript:void(0)">Absent</a>
          </li>
        </ul>
        <div *ngIf="loading" class="d-flex justify-content-center my-4">
          <c-spinner class="text-black" variant="border" label="Loading..."></c-spinner>
        </div>
        <!-- Clocked In Tab -->
        <div [hidden]="activeTab !== 'clockedIn'">
          <div class="d-flex align-items-center gap-2 mb-2" style="width:98%;margin:0 auto;">
            <div class="me-3">
              <span class="fw-bold">Total:</span>
              <span>{{ clockedInTotalItems }}</span>
            </div>
            <button type="button" class="btn btn-primary btn-sm mx-2" [disabled]="loading" (click)="loadClockedInEmployees(clockedInPage)">
              Refresh
              <c-spinner class="text-white" variant="border" label="Loading..." size="sm" *ngIf="loading"></c-spinner>
            </button>
            <select class="form-select form-select-sm w-auto" [(ngModel)]="clockedInPerPage" name="clockedInPerPage" (change)="loadClockedInEmployees(1)">
              <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{ size }} / page</option>
            </select>
            <div class="d-flex align-items-center gap-1">
              <button class="btn btn-outline-primary btn-sm" [disabled]="clockedInPage === 1" (click)="onClockedInPageChange(clockedInPage - 1)">&larr;</button>
              <ng-container *ngFor="let page of [].constructor(clockedInTotalPages); let idx = index">
                <button type="button" class="btn btn-sm" [ngClass]="{'btn-primary': clockedInPage === (idx+1), 'btn-outline-primary': clockedInPage !== (idx+1)}" (click)="onClockedInPageChange(idx+1)">{{ idx+1 }}</button>
              </ng-container>
              <button class="btn btn-outline-primary btn-sm" [disabled]="clockedInPage === absentTotalPages" (click)="onClockedInPageChange(clockedInPage + 1)">&rarr;</button>
            </div>
          </div>
          <table cTable class="table-hover mb-2" style="width:98%;margin:0 auto;" *ngIf="!loading && clockedInData.length > 0; else noClockedIn">
            <thead class="table-primary table-header-full">
              <tr>   
                <th>First Name</th>
                <th>Last Name</th>
                <th>Employee ID</th>             
                <th>Email Address</th>
                <th>Time In</th>
                <th>Time Out</th>
                <th>Remarks</th>
                <th>Total Hours</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of clockedInData">
                <td>{{ record?.first_name }}</td>
                <td>{{ record?.last_name }}</td>
                <td>{{ record.employee_id || '' }}</td>
                <td>{{ record.email_address || '' }}</td>
                <td>{{ record.time_in || '' }}</td>
                <td>{{ record.time_out || '' }}</td>
                <td>{{ record.remarks || '' }}</td>
                <td>{{ record.total_hours || '' }}</td>
              </tr>
            </tbody>
          </table>
          <ng-template #noClockedIn>
            <div class="alert alert-info text-center mb-2" style="width:98%;margin:0 auto;">
              No employees clocked in
            </div>
          </ng-template>
        </div>
        <!-- Absent Tab -->
        <div [hidden]="activeTab !== 'absent'">
          <div class="d-flex align-items-center gap-2 mb-2" style="width:98%;margin:0 auto;">
            <div class="me-3">
              <span class="fw-bold">Total:</span>
              <span>{{ absentTotalItems }}</span>
            </div>
            <button type="button" class="btn btn-primary btn-sm mx-2" [disabled]="loading" (click)="loadAbsentEmployees(absentPage)">
              Refresh
              <c-spinner class="text-white" variant="border" label="Loading..." size="sm" *ngIf="loading"></c-spinner>
            </button>
            <select class="form-select form-select-sm w-auto" [(ngModel)]="absentPerPage" name="absentPerPage" (change)="loadAbsentEmployees(1)">
              <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{ size }} / page</option>
            </select>
            <div class="d-flex align-items-center gap-1">
              <button class="btn btn-outline-primary btn-sm" [disabled]="absentPage === 1" (click)="onAbsentPageChange(absentPage - 1)">&larr;</button>
              <ng-container *ngFor="let page of [].constructor(absentTotalPages); let idx = index">
                <button type="button" class="btn btn-sm" [ngClass]="{'btn-primary': absentPage === (idx+1), 'btn-outline-primary': absentPage !== (idx+1)}" (click)="onAbsentPageChange(idx+1)">{{ idx+1 }}</button>
              </ng-container>
              <button class="btn btn-outline-primary btn-sm" [disabled]="absentPage === absentTotalPages" (click)="onAbsentPageChange(absentPage + 1)">&rarr;</button>
            </div>
          </div>
          <table cTable class="table-hover mb-2" style="width:98%;margin:0 auto;" *ngIf="!loading && absentData.length > 0; else noAbsent">
            <thead class="table-danger table-header-full">
              <tr>
                <th>Date Hired</th>
                <th>Employee ID</th>
                <th>Email Address</th>
                <th>First Name</th>
                <th>Last Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let emp of absentData">
                <td>{{ emp.date_hired ? (emp.date_hired | date:'yyyy-MM-dd') : '' }}</td>
                <td>{{ emp.employee_id || '' }}</td>
                <td>{{ emp.email_address || '' }}</td>
                <td>{{ emp.first_name || '' }}</td>
                <td>{{ emp.last_name || '' }}</td>
              </tr>
            </tbody>
          </table>
          <ng-template #noAbsent>
            <div class="alert alert-info text-center mb-2" style="width:98%;margin:0 auto;">
              No absent employees
            </div>
          </ng-template>
        </div>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>